module.exports = "/shared/img/ticket-background.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/ticket-background.png
// module id = 454
// module chunks = 13